import * as React from "react";
const SvgFiRrBasketball = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-basketball_svg__a)">
      <path
        fill="#062147"
        d="M12.003-.002C5.365-.002-.016 5.378-.016 12.016s5.381 12.019 12.019 12.019 12.019-5.381 12.019-12.019S18.64-.002 12.002-.002m9.94 10.944-.005-.004a9.94 9.94 0 0 1-5.275-2.2l3.07-3.07a9.95 9.95 0 0 1 2.21 5.274m-3.628-6.69-3.066 3.076a9.93 9.93 0 0 1-2.2-5.275 9.95 9.95 0 0 1 5.266 2.2m-7.262-2.204a11.93 11.93 0 0 0 2.783 6.702L12 10.586 5.676 4.262a9.96 9.96 0 0 1 5.377-2.214M4.26 5.676l-.004-.004zL10.585 12l-1.837 1.837a11.92 11.92 0 0 0-6.7-2.784A9.96 9.96 0 0 1 4.26 5.676m-2.204 7.382v-.004c1.936.2 3.77.965 5.275 2.2l-3.07 3.07a9.95 9.95 0 0 1-2.205-5.266m3.623 6.68 3.066-3.07a9.93 9.93 0 0 1 2.2 5.275 9.95 9.95 0 0 1-5.266-2.205m7.267 2.214a11.92 11.92 0 0 0-2.784-6.701L12 13.414l6.324 6.324a9.95 9.95 0 0 1-5.377 2.214m6.789-3.628L13.414 12l1.836-1.836a11.93 11.93 0 0 0 6.7 2.783 9.96 9.96 0 0 1-2.214 5.377"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-basketball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBasketball;
